import CoInvestmentForm from "./CoInvestmentForm";

export default CoInvestmentForm;
